import React, { FC } from 'react';
import Icon from '@ant-design/icons';

export const FileUploadActiveTwoTone: FC = props => (
  <Icon component={FileUploadActiveTwoSVG} {...props} />
);

const FileUploadActiveTwoSVG = () => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M20.7741 26.2667C17.9607 26.4667 17.9607 30.5467 20.7741 30.7467H27.4541C28.2674 30.7467 29.0407 30.4534 29.6407 29.9067C31.6141 28.1867 30.5607 24.72 27.9607 24.4C27.0274 18.7734 18.8807 20.9067 20.8141 26.2667'
      fill='#007BFB'
    />
    <path
      d='M20.7741 26.2667C17.9607 26.4667 17.9607 30.5467 20.7741 30.7467H27.4541C28.2674 30.7467 29.0407 30.4534 29.6407 29.9067C31.6141 28.1867 30.5607 24.72 27.9607 24.4C27.0274 18.7734 18.8807 20.9067 20.8141 26.2667'
      fill='#007BFB'
    />
    <path
      d='M29.3327 14.7598V20.4532C29.3327 20.8798 28.6527 21.0665 28.3594 20.7598C27.7327 20.1065 26.946 19.6132 26.0394 19.3332C23.946 18.6798 21.5327 19.3198 20.0127 20.8932C19.0527 21.9198 18.5327 23.1998 18.506 24.5865C18.506 24.8265 18.386 25.0398 18.1993 25.1865C17.2393 25.9465 16.6527 27.1332 16.6527 28.4932V28.5065C16.6527 28.9332 16.346 29.3198 15.9193 29.3198H9.78602C5.86602 29.3332 2.66602 26.1332 2.66602 22.1998V8.55984C2.66602 5.3065 5.30602 2.6665 8.55935 2.6665H11.6527C13.826 2.6665 14.506 3.37317 15.3727 4.53317L17.2393 7.01317C17.6527 7.55984 17.706 7.6265 18.4793 7.6265H22.1993C25.3727 7.6265 28.066 9.7065 28.986 12.5865C29.186 13.1865 29.2927 13.7998 29.3193 14.4532C29.3327 14.5465 29.3327 14.6665 29.3327 14.7598Z'
      fill='#007BFB'
    />
  </svg>
);
